import { Injectable } from '@angular/core';
import { EnvConfig } from '../models/env-config';
import { SessionStorageService } from './session-storage.service';

type RewriteMessage = {
  from: string;
  to: string;
};

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  rewriteMessages: any;

  updateRewriteMessages(envConfig: EnvConfig) {
    this.rewriteMessages = [];

    Object.entries(envConfig).forEach(([key, value]) => {
      if (key.includes('rewritemessage')) {
        const [messagePrefix, messageKey, messageAttr] = String(key).split('.');

        if (!this.rewriteMessages[messageKey])
          this.rewriteMessages[messageKey] = {};

        this.rewriteMessages[messageKey][messageAttr] = value;
      }
    });
  }

  getMessageRewrite(messageFrom: string) {
    let messageTo = '';

    if(this.rewriteMessages){
      Object.entries(this.rewriteMessages).forEach(([key, value]) => {
        const rewriteMessageObj = value as RewriteMessage;
  
        if (
          rewriteMessageObj.from &&
          messageFrom.includes(rewriteMessageObj.from)
        ) {
          messageTo = rewriteMessageObj?.to;
        }
      });
    }


    return messageTo || messageFrom;
  }

  getMessageFromError(err: any, envConfig?: EnvConfig): string {
    // Regex that will get the values between [], the first should contain the error code
    // the second contains the error message
    const regex = new RegExp('(\\[(?:\\[??[^\\[]*?\\]))', 'g');
    const firstError = err.error?.errors?.[0].match(regex);

    let message = '';
    if (firstError?.[0]?.includes('4007') || firstError?.[0]?.includes('4009') || firstError?.[0]?.includes('4010')) {
      message = (envConfig as any)?.['mensagem.proposta.cpf.duplicado'] || 
        'Ocorreu um erro inesperado. Tente novamente mais tarde';
    } else {
      message = 'Ocorreu um erro inesperado. Tente novamente mais tarde';
    }

    const rewriteMessage = this.getMessageRewrite(message);
    if (rewriteMessage) message = rewriteMessage;

    return message;
  }

  constructor() {}
}
